export const toTitleCase = (str) => {
  return str
    ?.trim()
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

export function generateSlug(name) {
  if (!name) return "";

  return name
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");
}

export function generateCanonicalUrl(customPath = "", name) {
  const currentPath = customPath || window.location.pathname;
  const titleCaseName = name ? toTitleCase(name) : "";
  return `${window.location.origin}${currentPath}${titleCaseName ? `/${titleCaseName}` : ""}`;
}

export function formatApiRequest(slug, forUrl = false) {
  if (!slug) return "";
  const formattedSlug = slug
    .split(/[-:]/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return forUrl ? encodeURIComponent(formattedSlug) : formattedSlug;
}
